'use client';

import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import RecentlyViewedList from './RecentlyViewedList';
import RecentlyViewedListSkeleton from './RecentlyViewedListSkeleton';
import SectionContainer from '@/components/shared/SectionContainer';
import QueryBoundary from '@/components/ui/QueryBoundary';

type RecentlyViewedSectionProps = {
  recentlyViewedIds: string[];
};

const RecentlyViewedSection = ({ recentlyViewedIds }: RecentlyViewedSectionProps) => {
  return (
    <SectionContainer
      containerWrapperProps={{
        backgroundColor: 'common.100',
        paddingY: { base: 12, tablet: 12, desktop: 16 },
      }}
    >
      <Flex alignItems="center" justifyContent="space-between" marginBottom={8}>
        <Flex alignItems="center" gap={4}>
          <Text color="neutral.90" textStyle="heading2" fontWeight="regular">
            Recently Viewed
          </Text>
        </Flex>
      </Flex>
      <QueryBoundary loadingFallback={<RecentlyViewedListSkeleton length={recentlyViewedIds.length} />}>
        <RecentlyViewedList recentlyViewedIds={recentlyViewedIds} />
      </QueryBoundary>
    </SectionContainer>
  );
};

export default RecentlyViewedSection;
